import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const DEFAULT_AREA = "General";

export function firstLine(text: string, max = 100): string {
  const line = (text || "").split("\n").find((l) => l.trim()) ?? "";
  return line.length > max ? line.slice(0, max - 1) + "…" : line;
}

export function formatTimestamp(iso: string, tz: string): string {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-US", {
      timeZone: tzAbbreviationToIana(tz),
      hour12: false,
    });
  } catch {
    return iso;
  }
}

// Best-effort mapping for common abbreviations. Falls back to UTC if unknown.
const TZ_MAP: Record<string, string> = {
  UTC: "UTC",
  GMT: "Etc/GMT",
  PST: "America/Los_Angeles",
  PDT: "America/Los_Angeles",
  MST: "America/Denver",
  MDT: "America/Denver",
  CST: "America/Chicago",
  CDT: "America/Chicago",
  EST: "America/New_York",
  EDT: "America/New_York",
  CET: "Europe/Paris",
  CEST: "Europe/Paris",
  IST: "Asia/Kolkata",
  JST: "Asia/Tokyo",
  AEST: "Australia/Sydney",
  AEDT: "Australia/Sydney",
};

export function tzAbbreviationToIana(abbr: string): string {
  if (!abbr) return "UTC";
  const upper = abbr.toUpperCase();
  return TZ_MAP[upper] ?? abbr; // pass through if it's already an IANA name
}
